export function spotNumber(point) {
  const given = Number(point?.number);
  if (Number.isFinite(given) && given > 0) return given;
  const match = String(point?.id || "").match(/^pt_nq_(\d+)$/);
  return match ? Number(match[1]) : null;
}

export function withSpotNumbers(points) {
  const used = new Set();
  const known = points.map((point) => {
    const number = spotNumber(point);
    if (number) used.add(number);
    return { ...point, number };
  });
  let next = used.size ? Math.max(...used) + 1 : 1;
  return known.map((point) => {
    if (point.number) return point;
    const number = next;
    next += 1;
    used.add(number);
    return { ...point, number };
  });
}

export function nextSpotNumber(points, retired = []) {
  const used = withSpotNumbers(points).map((point) => point.number);
  retired.forEach((number) => used.push(Number(number)));
  const finite = used.filter((number) => Number.isFinite(number));
  return (finite.length ? Math.max(...finite) : 0) + 1;
}
